/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const radiobrus: CommunityData = {
  code: "radiobrus",
  inviteCode: "radiobrus",
  name: "BRUS",
  thumbnail: "/assets/customizations/radioBrus/radio-brus-thumbnail.png",
  favicon: "",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/bru-213`,
  socials: {
    instagramLink: "https://instagram.com/radio.brus",
    soundcloudLink: "https://soundcloud.app.goo.gl/jnDfDdH9fH7GcMDE7",
  },
  styles: {
    global: {
      counterColor: "#232734",
      alternativeLogo: {
        src: "/assets/customizations/radioBrus/logo-white.svg",
        styles: "w-[84px] sm:w-[60px]",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      logo: {
        src: "/assets/customizations/radioBrus/logo.svg",
        styles: "w-[84px] sm:w-[104px]",
      },
      contentBoxShadow: "",
      bgColor: "#B2B2B2",
      asideBg: "#0000FF",
      asideStyles: "",
      contentBg: "#ffffff",
      bgDesktop: "/assets/customizations/radioBrus/radio-brus-video-bg.mp4",
      bgMobile: "/assets/customizations/radioBrus/radio-brus-video-bg-mobile.mp4",
      mainFont: "font-['FKRasterGrotesk']",
      primaryButton:
        "px-5 py-4 uppercase text-sm rounded-[10px] text-white disabled:opacity-20 text-[14px] font-bold w-full sm:w-fit bg-[#0000FF] font-['DMMono']",
    },
    navigation: {
      sideBarSeparator: "",
      iconsColor: "#ffffff",
      separator: "border-white border-t",
      item: "text-[18px] uppercase font-['DMMono'] leading-[18px] h-[40px] flex sm:justify-start justify-center items-center text-[#FFFFFF]",
      itemSelected: "bg-[#BEBEBE] bg-opacity-30",
    },
    communityLanding: {
      titles: "font-bold text-[#0000FF] text-[24px] leading-[24px] pb-2",
      announcements: {
        customBg: "bg-[#0000FF]",
        lg: {
          title: "font-bold text-[20px] leading-[28px]",
          subtitle: "font-bold text-[13px] leading-[13px] font-['DMMono']",
        },
        sm: {
          title: "font-bold text-[20px] leading-[28px]",
          subtitle: "font-bold text-[13px] leading-[13px] font-['DMMono']",
        },
      },
      event: {
        title: "font-bold text-[13px] text-[#0000FF] leading-5",
        subtitle: "font-bold text-[13px] text-[#0000FF] leading-5 font-['DMMono']",
      },
      shop: {
        title: "font-medium text-[20px] text-[#0000FF] leading-[20px]",
        text: "font-medium text-[12px] text-[#0000FF] leading-1 font-['DMMono']",
        customShopImage: "/assets/customizations/radioBrus/radio-brus-shop-logo.png",
      },
      emptyOrLoadingState: "",
    },
    announcements: {
      emptyOrLoadingState: "font-bold font-['DMMono'] text-[20px] leading-[20px] mb-[500px]",
      created: "text-[#0000FF]",
      container: "mb-16 sm:p-11 p-7 sm:space-y-[38px] space-y-[33px]",
      header: "font-bold text-[#0000FF]  text-[24px] leading-[24px]",
      title: "font-bold text-[#0000FF] text-[24px] leading-[24px] pb-2",
      description: "text-[12px] text-[#0000FF] leading-[15px] font-['DMMono']",
    },
    announcement: {
      likeCount: "",
      commentCount: "",
      emptyOrLoadingState: "font-bold font-['DMMono'] text-[20px] leading-[20px] mb-[500px]",
      created: "text-[#0000FF]",
      container: "sm:p-10 p-7 pb-8 space-y-[23px]",
      title: "font-bold text-[#0000FF] text-[24px] leading-[24px] pb-2",
      description: "text-[12px] text-[#0000FF] leading-[15px] font-['DMMono']",
      commentIconColor: "",
      likeIconColor: "",
    },
    events: {
      sectionHeader: "uppercase text-[#0000FF] font-['DMMono']",
      container: "mb-16 sm:p-11 p-7 sm:pb-8 sm:space-y-[57px] space-y-[25px]",
      header: "font-bold text-[#0000FF] text-[24px] leading-[24px] pb-2",
      title: "font-bold text-[#0000FF] text-[24px] leading-[24px] py-2",
      emptyOrLoadingState: "font-bold font-['DMMono'] text-[20px] leading-[20px] my-8",
      duration: "text-[12px] text-[#0000FF] leading-[15px] font-['DMMono'] mb-1",
      address: "text-[12px] text-[#0000FF] leading-[15px] font-['DMMono']",
      separator: "mb-8 mt-2 border-b border-b-[1px] border-[#0000FF]",
    },
    event: {
      blockContainer: "flex flex-col gap-3",
      container: "flex flex-col sm:p-11 p-6",
      emptyOrLoadingState: "font-bold font-['DMMono'] text-[20px] leading-[20px] my-8",
      header: "font-bold text-[#0000FF] text-[24px] leading-[30px] sm:mb-0 mb-5 uppercase",
      sectionTitle: "text-[25px] text-[#0000FF] leading-10 sm:leading-8",
      sectionSubtitle:
        "font-medium text-[12px] text-[#0000FF] leading-[12px] font-['DMMono'] uppercase",
      text: "text-[12px] text-[#0000FF] leading-[15px] font-['DMMono']",
      separator: "sm:my-8 my-6 border-b border-b-[1px] border-[#0000FF]",
      map: {
        pin: "",
        border: "border border-solid border-[#0000FF]",
        pinColor: "#0000FF",
        strokeColor: "",
      },
    },
    eventTickets: {
      separator: "sm:my-8 my-6 border-b border-b-[1px] border-[#0000FF]",
      container: "flex flex-col sm:p-11 p-6",
      event: {
        title: "font-bold text-[#0000FF] text-[24px] leading-[30px] mb-0 sm:mt-2 mt-0 uppercase",
        subtitle: "font-medium text-[12px] text-[#0000FF] leading-[12px] font-['DMMono'] uppercase",
      },
      ticket: {
        counterContainer: "",
        title: "font-bold text-[24px] leading-[1] text-[#0000FF]",
        description: "text-base leading-4 text-[#0000FF] font-['DMMono']",
        text: "font-medium text-[13px] leading-[20px] text-[#0000FF] font-['DMMono']",
        price: "font-bold text-[16px] leading-[16px] text-[#0000FF]",
        quantity: "font-bold sm:text-[12px] text-[11px] leading-[12px] text-[#0000FF]",
      },
    },
    shop: {
      sectionTitle: "text-[#0000FF] font-['DMMono'] uppercase",
      separator: "mt-2 sm:mb-7 mb-6 border-b border-b-[1px] border-[#0000FF]",
      container: "mb-16 sm:p-11 p-7 sm:pb-8",
      emptyState: "font-bold font-['DMMono'] text-[20px] leading-[20px] my-8 text-[#0000FF]",
      header: "font-bold text-[#0000FF] text-[24px] leading-[24px]",
    },
  },
}

export default radiobrus
